import { nanoid } from 'nanoid';
import React from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';
import Svg, { Rect, Path } from 'react-native-svg';

const InfoIconV2 = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    const gradientId = nanoid();

    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 43}
          height={props.height ?? 38}
          viewBox="0 0 43 38"
          fill="none"
          {...props}
        >
          <Rect width="43" height="38" rx="8" fill={props.color ?? '#FFF5DD'} />
          <Path
            d="M21.5 29C15.99 29 11.5 24.51 11.5 19C11.5 13.49 15.99 9 21.5 9C27.01 9 31.5 13.49 31.5 19C31.5 24.51 27.01 29 21.5 29ZM20.75 23C20.75 23.41 21.09 23.75 21.5 23.75C21.91 23.75 22.25 23.41 22.25 23V18C22.25 17.59 21.91 17.25 21.5 17.25C21.09 17.25 20.75 17.59 20.75 18V23ZM22.42 14.62C22.37 14.49 22.3 14.39 22.21 14.29C22.11 14.2 22 14.13 21.88 14.08C21.76 14.03 21.63 14 21.5 14C21.37 14 21.24 14.03 21.12 14.08C21 14.13 20.89 14.2 20.79 14.29C20.7 14.39 20.63 14.49 20.58 14.62C20.53 14.74 20.5 14.87 20.5 15C20.5 15.13 20.53 15.26 20.58 15.38C20.63 15.5 20.7 15.61 20.79 15.71C20.89 15.8 21 15.87 21.12 15.92C21.36 16.02 21.64 16.02 21.88 15.92C22 15.87 22.11 15.8 22.21 15.71C22.3 15.61 22.37 15.5 22.42 15.38C22.47 15.26 22.5 15.13 22.5 15C22.5 14.87 22.47 14.74 22.42 14.62Z"
            fill="#292D32"
          />
        </Svg>
      </View>
    );
  },
);

export { InfoIconV2 };
